import { render, staticRenderFns } from "./wxsdevices.vue?vue&type=template&id=39170cf4&"
import script from "./wxsdevices.vue?vue&type=script&lang=js&"
export * from "./wxsdevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports